import * as classnames from 'classnames'
import Color from 'color'
import * as PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { minBy, maxBy } from 'lodash'
import { ViewerItem, MOVE_NONE } from '@teqplay/viewer'

import { getAtaOrCargoStart, getAtdOrCargoEnd } from '../../../utils/terminalVisitConflictsUtils'
import { visitIsCompleted } from '../../../utils/terminalVisitUtils'
import './SeaShipShadow.scss'

export default class SeaShipShadow extends PureComponent {
  static propTypes = {
    terminalVisit: PropTypes.object.isRequired,
    orders: PropTypes.array.isRequired,
    timeToScreen: PropTypes.func.isRequired,
    bollardToScreen: PropTypes.func.isRequired,
    offset: PropTypes.number.isRequired,
    minBollard: PropTypes.number,
    maxBollard: PropTypes.number,
    zIndex: PropTypes.number
  }

  render() {
    // calculate shifted bollards
    const { bollardStart, bollardEnd } = this.calculateBollards()
    if (bollardEnd <= bollardStart) {
      return null
    }

    const shadowTerminalVisit = this.convertTerminalVisit({
      bollardStart,
      bollardEnd
    })
    const classes = classnames('seaship-shadow-wrapper', {
      completed: visitIsCompleted(this.props.terminalVisit)
    })

    const largestOrder = maxBy([...this.props.orders], 'amount')

    const backgroundColor = largestOrder.color
    const borderColor = Color(backgroundColor).darken(0.4).toString()

    const style = {
      backgroundColor,
      borderColor,
      zIndex: this.props.zIndex
    }

    return (
      <ViewerItem
        key={this.props.terminalVisit._id}
        item={shadowTerminalVisit}
        movement={MOVE_NONE}
        yUnitToScreen={this.props.timeToScreen}
        xUnitToScreen={this.props.bollardToScreen}
        className={classes}
        style={style}
      >
        <div className="ship-details-wrapper">
          {this.props.terminalVisit.ship.name
            ? this.props.terminalVisit.ship.name
            : `${this.props.terminalVisit.ship.length} m`}
        </div>

        <div className="ship-details-wrapper">
          {this.props.orders.map(order => (
            <div key={order.uuid} className="seaship-shadow-wrapper--order-info">
              {order.operation === 'unloading' ? (
                <i className="fa fa-arrow-up" aria-hidden="true" />
              ) : (
                <i className="fa fa-arrow-down" aria-hidden="true" />
              )}
              {order.amount ? ` ${order.amount} mt ` : '(no cargo specified)'}
            </div>
          ))}
        </div>
      </ViewerItem>
    )
  }

  convertTerminalVisit = ({ bollardStart, bollardEnd }) => {
    const firstOrder = minBy(this.props.orders, 'cargoStart')
    const lastOrder = maxBy(this.props.orders, 'cargoEnd')

    const startTime = new Date(getAtaOrCargoStart(this.props.terminalVisit, firstOrder))
    const endTime = new Date(getAtdOrCargoEnd(this.props.terminalVisit, lastOrder))

    return {
      _id: this.props.terminalVisit._id,
      xStart: bollardStart,
      xEnd: bollardEnd,
      yStart: startTime,
      yEnd: endTime
    }
  }

  calculateBollards() {
    // TODO: create a util function limit() for this

    const minBollardStart = Math.min(...this.props.orders.map(ord => ord.bollardStart))
    const maxBollardEnd = Math.max(...this.props.orders.map(ord => ord.bollardEnd))

    const bollardStart = minBollardStart + this.props.offset
    const limitedBollardStart =
      typeof this.props.minBollard === 'number' ? Math.max(bollardStart, this.props.minBollard) : bollardStart

    const bollardEnd = maxBollardEnd + this.props.offset
    const limitedBollardEnd =
      typeof this.props.maxBollard === 'number' ? Math.min(bollardEnd, this.props.maxBollard) : bollardEnd

    return {
      bollardStart: limitedBollardStart,
      bollardEnd: limitedBollardEnd
    }
  }
}
